(function ($) {
  $(function () {
    var $window = $(window);
    var $videoThumbnailCardsWrapper = $('.video-thumbnail-card__wrapper');
    $videoThumbnailCardsWrapper.length ? console.log('true'): $videoThumbnailCardsWrapper = $('.video-card-carousel__wrapper');

    if ($videoThumbnailCardsWrapper.length) {
      var $window = $(window);
      var videoThumbnailCardsSlider = (function () {
        var $container = $('.container');

        function initVideoThumbnailCardsSlider($slider) {
          var countSlides = $slider.find('.video-thumbnail-card').length;
          var slickSettings = {
            infinite: false,
            swipe: true,
            slidesToScroll: 1,
            slidesToSwipe: 1,
            arrows: true,
            variableWidth: true,
            responsive: [
              {
                breakpoint: 1280,
                settings: {
                  slidesToShow: getSlideCount($slider),
                  variableWidth: false,
                  arrows: true,
                  dots: false,
                },
              },
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: 2,
                  variableWidth: false,
                  arrows: false,
                  dots: true,
                },
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1,
                  variableWidth: false,
                  arrows: false,
                  dots: true,
                },
              },
            ],
          };

          $slider.slick(slickSettings);

          if (
            $window.width() > 1280 &&
            countSlides <= getSlideCount($slider) &&
            $slider.hasClass('slick-initialized')
          ) {
            $slider.slick('slickSetOption', 'draggable', false, false);
            $slider.slick('slickSetOption', 'swipe', false, false);
            $slider.find('.slick-arrow').addClass('slick-disabled');
            return;
          } else if (
            $window.width() <= 1280 &&
            $window.width() > 991 &&
            countSlides <= getSlideCount($slider) &&
            $slider.hasClass('slick-initialized')
          ) {
            $slider.slick('slickSetOption', 'draggable', false, false);
            $slider.slick('slickSetOption', 'swipe', false, false);
            $slider.find('.slick-arrow').addClass('slick-disabled');
            return;
          } else if (
            $window.width() <= 991 &&
            $window.width() > 767 &&
            countSlides <= 2 &&
            $slider.hasClass('slick-initialized')
          ) {
            $slider.slick('slickSetOption', 'draggable', false, false);
            $slider.slick('slickSetOption', 'swipe', false, false);
            $slider.find('.slick-arrow').addClass('slick-disabled');
            return;
          } else if (
            $window.width() <= 767 &&
            countSlides <= 1 &&
            $slider.hasClass('slick-initialized')
          ) {
            $slider.slick('slickSetOption', 'draggable', false, false);
            $slider.slick('slickSetOption', 'swipe', false, false);
            $slider.find('.slick-arrow').addClass('slick-disabled');
            return;
          }
        }

        function setSlickListOffsetOnInitBreakpointChange($slider) {
          $slider.on('init breakpoint', function(event, slick) {
            setSlickListTranslateX($slider);
          });
        }

        function disableNextBtnBeforeLastSlideOnDesktop($slider) {
          $slider.on('afterChange', function(event, slick, currentSlideIndex) {
            if ($window.width() > 1280) {
              if (currentSlideIndex == (slick.$slides.length - getSlideCount($slider) - 1) ) {
                $slider.find('.slick-next').addClass('slick-disabled').attr('aria-disabled', 'true');
              }
            }
          });
        }
        
        function disableNextBtnBeforeLastSlide($slider) {
          $slider.on('afterChange', function(event, slick, currentSlideIndex) {
            if ((slick.$slides.length - getSlideCount($slider)) <= currentSlideIndex) {
              $slider.find('.slick-next').addClass('slick-disabled').attr('aria-disabled', 'true');
            }
          });
        }

        function showLastSlideFullyOnTabletLandscape($slider) {
          $slider.on('beforeChange', function(event, slick, currentSlideIndex) {
            if ((slick.$slides.length - getSlideCount($slider)) <= (currentSlideIndex + 1)) {
              var containerPaddingLeft = parseInt($container.css('padding-left'), 10);
              var translateX = (containerPaddingLeft * -1) + 'px';
              
              if ($window.width() >= 992 && $window.width() <= 1024) {
                $slider.find('.slick-list').css('transform', 'translate3d(' + translateX + ', 0, 0)');
              }
            } else {
              if ($window.width() >= 992 && $window.width() <= 1024) {
                var offsetLeft = parseInt($container.offset().left, 10) - parseInt($('main').offset().left, 10);
                var paddingLeft = parseInt($container.css('padding-left'), 10);
                var translateX = (offsetLeft + paddingLeft) + 'px';
            
                $slider.find('.slick-list').css('transform', 'translate3d(' + translateX + ', 0, 0)');
              }
            }
          });
        }

        function setSlickListTranslateX($slider) {
          if ($slider.find('.slick-list').length && $window.width() >= 992) {
            var offsetLeft = parseInt($container.offset().left, 10) - parseInt($('main').offset().left, 10);
            var paddingLeft = parseInt($container.css('padding-left'), 10);
            var translateX = (offsetLeft + paddingLeft) + 'px';
            
            $slider.find('.slick-list').css('transform', 'translate3d(' + translateX + ', 0, 0)');
          }
        }

        function getSlideCount($slider) {
          var slideWidthByGridCols = parseInt(getColValue($slider.find('[class*="col-"]').attr('class')), 10);

          if (slideWidthByGridCols === 5) {
            return 2;
          } else if (slideWidthByGridCols === 4) {
            return 3;
          } else {
            return 3;
          }
        }

        function getColValue(classNames) { 
          var colLength;

          classNames.split(" ").forEach(function (className) {
            if (className.indexOf('col-') !== -1) {
              colLength = className.slice(-1);
            }
          });

          return colLength;
        }

        return {
          init: function () {
            var self = this;

            if ($videoThumbnailCardsWrapper.length) {
              $videoThumbnailCardsWrapper.each(function () {
                var $thisSlider = $(this);

                self.setSlickOffset($thisSlider);
                initVideoThumbnailCardsSlider($thisSlider);
                self.disableNextButton($thisSlider);
                self.disableNextButtonOnDesktop($thisSlider);
                self.showLastSlideFullyOnTabletLandscape($thisSlider);
              });
            }
          },
          setSlickOffset: setSlickListOffsetOnInitBreakpointChange,
          disableNextButton: disableNextBtnBeforeLastSlide,
          disableNextButtonOnDesktop: disableNextBtnBeforeLastSlideOnDesktop,
          showLastSlideFullyOnTabletLandscape: showLastSlideFullyOnTabletLandscape,
          setSlickListOffsetOnResize: function () {
            if ($videoThumbnailCardsWrapper.length) {
              $videoThumbnailCardsWrapper.each(function () {
                var $thisSlider = $(this);
                setSlickListTranslateX($thisSlider);
              });
            }
          }
        }
      })();

      videoThumbnailCardsSlider.init();

      $window.on('resize', videoThumbnailCardsSlider.setSlickListOffsetOnResize);
    }
  });
})(jQuery);